// Mock data for Doktor Gigi website

export const symptoms = [
  {
    id: 1,
    icon: "Zap",
    title: "Severe Pain",
    description: "Sharp pain in your side and back, below the ribs",
    color: "text-red-500",
    bgColor: "bg-red-50"
  },
  {
    id: 2,
    icon: "Flame",
    title: "Burning Sensations",
    description: "Pain or burning sensation while urinating",
    color: "text-orange-500",
    bgColor: "bg-orange-50"
  },
  {
    id: 3,
    icon: "Droplets",
    title: "Blood in Urine",
    description: "Pink, red or brown urine indicating stones",
    color: "text-red-400",
    bgColor: "bg-red-50"
  },
  {
    id: 4,
    icon: "Heart",
    title: "Nausea & Vomiting",
    description: "Feeling sick combined with intense waves of pain",
    color: "text-teal-500",
    bgColor: "bg-teal-50"
  }
];

export const howItHelps = [
  {
    id: 1,
    step: "01",
    icon: "MessageSquare",
    title: "Share Your Symptoms",
    description: "Tell us about your pain, history, and any reports you have"
  },
  {
    id: 2,
    step: "02",
    icon: "Users",
    title: "Connect with Specialist",
    description: "Get matched with an experienced kidney specialist"
  },
  {
    id: 3,
    step: "03",
    icon: "FileText",
    title: "Get Clear Explanation",
    description: "Understand your condition in simple, clear language"
  },
  {
    id: 4,
    step: "04",
    icon: "HeartHandshake",
    title: "Treatment & Follow-up",
    description: "Receive personalized treatment plan and ongoing support"
  }
];

export const treatmentOptions = [
  {
    id: 1,
    icon: "Pill",
    title: "Medicines",
    description: "Pain relief to help pass smaller stones naturally"
  },
  {
    id: 2,
    icon: "Utensils",
    title: "Diet Changes",
    description: "Dietary modifications to prevent new stones"
  },
  {
    id: 3,
    icon: "Zap",
    title: "Laser Treatment",
    description: "Minimally invasive procedure to break larger stones"
  },
  {
    id: 4,
    icon: "Scissors",
    title: "Surgery",
    description: "For complex cases that don't respond to medicine"
  }
];

export const comparisonData = [
  {
    feature: "Procedure Type",
    eswl: "Non-invasive",
    ursl: "Minimally Invasive",
    pcnl: "Minimally Invasive",
    openSurgery: "Invasive"
  },
  {
    feature: "Anesthesia",
    eswl: "Sedation / Local",
    ursl: "General / Spinal",
    pcnl: "General",
    openSurgery: "General"
  },
  {
    feature: "Hospital Stay",
    eswl: "Outpatient",
    ursl: "1-2 Days",
    pcnl: "2-4 Days",
    openSurgery: "5-7 Days"
  },
  {
    feature: "Recovery Time",
    eswl: "1-2 Days",
    ursl: "1-2 Weeks",
    pcnl: "2-3 Weeks",
    openSurgery: "4-6 Weeks"
  },
  {
    feature: "Best For Stone Size",
    eswl: "< 1 cm",
    ursl: "< 2 cm",
    pcnl: "> 2 cm",
    openSurgery: "Complex Cases"
  },
  {
    feature: "Success Rate",
    eswl: "70-90%",
    ursl: "90-95%",
    pcnl: "85-95%",
    openSurgery: "95-100%"
  },
  {
    feature: "Pain Level",
    eswl: "Mild",
    ursl: "Mild to Moderate",
    pcnl: "Moderate",
    openSurgery: "Significant"
  },
  {
    feature: "Scarring",
    eswl: "None",
    ursl: "None",
    pcnl: "Small (1 cm)",
    openSurgery: "Large"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Are kidney stones always painful?",
    answer: "Not always. Small stones can pass unnoticed. Pain typically occurs when a stone moves within the kidney or gets stuck in the ureter."
  },
  {
    id: 2,
    question: "Do I definitely need surgery?",
    answer: "No. Many stones pass with hydration and medication. Surgery is only considered for very large stones or persistent blockage."
  },
  {
    id: 3,
    question: "Is online consultation safe?",
    answer: "Absolutely. Our specialists review your scans and symptoms via HIPAA-compliant video calls to provide expert guidance."
  },
  {
    id: 4,
    question: "How long is the recovery after laser treatment?",
    answer: "Most patients return to light activities within 24-48 hours. Full recovery usually takes less than a week."
  },
  {
    id: 5,
    question: "Can kidney stones come back?",
    answer: "Yes, there is a 50% chance of recurrence if lifestyle changes aren't made. We provide personalized prevention plans."
  }
];

export const quickLinks = [
  { name: "Home", href: "/" },
  { name: "Blog", href: "/blog" },
  { name: "Contact", href: "/contact" }
];

export const contactInfo = {
  phone: "+91 95992 21351",
  email: "support@doktorgigi.com",
  availability: "24/7 Consultation",
  whatsapp: "https://wa.me/919599221351"
};

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Kidney Stones: Causes and Prevention",
    excerpt: "Learn about the common causes of kidney stones and how to prevent them through lifestyle changes.",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800",
    date: "July 15, 2025",
    author: "Dr. Sharma",
    category: "Prevention"
  },
  {
    id: 2,
    title: "Diet Tips for Kidney Stone Patients",
    excerpt: "Discover the best foods to eat and avoid if you're prone to kidney stones.",
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800",
    date: "July 10, 2025",
    author: "Dr. Patel",
    category: "Diet"
  },
  {
    id: 3,
    title: "When to See a Doctor for Kidney Pain",
    excerpt: "Know the warning signs that indicate you need immediate medical attention.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=800",
    date: "July 5, 2025",
    author: "Dr. Kumar",
    category: "Health Tips"
  },
  {
    id: 4,
    title: "Latest Advances in Kidney Stone Treatment",
    excerpt: "Explore the newest minimally invasive treatments available for kidney stones.",
    image: "https://images.unsplash.com/photo-1551076805-e1869033e561?w=800",
    date: "June 28, 2025",
    author: "Dr. Gupta",
    category: "Treatment"
  }
];
